import { useGoogleLogin } from '@react-oauth/google';
import { toast } from 'react-toastify';

import { LocalStore } from 'constants/localstore';
import { GOOGLE_SCOPE_YOUTUBE, MAX_TOKEN_TIME } from 'services/google/google.params';
import { useAppDispatch, useAppSelector } from 'store/store-hooks';
import { ModalEnum, setModal } from 'components/app/_mediator/app.slice';
import { uploadYtFile } from 'components/app/_mediator/app-files-upload.slice';

export const useFcShare = () => {
  const { selectedProject } = useAppSelector((state) => state.projects);
  const { projects } = useAppSelector((state) => state.app__data);
  const { id, name, url } = useAppSelector((state) => state.fc__data);
  const dispatch = useAppDispatch();

  const ytLogin = useGoogleLogin({
    onSuccess: async (res) => {
      localStorage.setItem(LocalStore.youtubeOAuth, res.access_token);
      localStorage.setItem(LocalStore.youtubeOAuthDate, Date.now().toString());
      await ytShare();
    },
    onError: (err) => console.log(err),
    scope: GOOGLE_SCOPE_YOUTUBE,
  });

  const ytReLogin = () => {
    const token = localStorage.getItem(LocalStore.youtubeOAuth);
    const tokenDate = localStorage.getItem(LocalStore.youtubeOAuthDate);
    if (token && tokenDate && Date.now() - Number(tokenDate) < MAX_TOKEN_TIME) dispatch(setModal(ModalEnum.ytReLogin));
    else ytShare();
  };

  const ytShare = async () => {
    if (!url || !id || !name) return;
    const project = projects?.find((e) => e.projectId == selectedProject);
    if (!project?.ownerName) return;
    const metadata = getYoutubeMetadata(id, name, project.ownerName);
    await dispatch(uploadYtFile({ fcId: id, metadata, url }))
      .unwrap()
      .catch((err) => {
        if (err === 401 || err === 403) ytLogin();
        else toast.error('Failed to upload to YouTube. Please try again.');
      });
  };

  const fbShare = () => {
    if (!id) return;
    window.open(getFbLink(id), '_blank', 'width=800,height=600,top=100,left=200,resizable=share');
  };

  return { fbShare, ytShare, ytReLogin, ytLogin };
};

/* H E L P E R S */

const getYoutubeMetadata = (fcId: FinalcutId, name: string, ownerName: string) => {
  let title = name;
  if (name.startsWith('Final Cut (')) title = name.replace('Final Cut (', '');
  if (title[title.length - 1] === ')') title = title.substring(0, title.length - 1);
  const metadata = {
    snippet: {
      title,
      description: `#Reflectography #Pulse https://www.youtube.com/@ReflectographyPulse\nCreated by ${ownerName} with Pulse - The best montage video editor ever!!!\nLink to the video: ${
        import.meta.env.VITE_DOMAIN_FRONT
      }/share?i=${fcId}`,
      categoryId: '22',
      tags: ['#Reflectography', '#Pulse'],
    },
    status: {
      privacyStatus: 'public',
      selfDeclaredMadeForKids: false,
    },
  };
  return JSON.stringify(metadata);
};

const getFbLink = (fcId: FinalcutId) => {
  const href = encodeURIComponent(
    `${import.meta.env.VITE_DOMAIN_FRONT}/share/${fcId}/${Date.now().toString().substring(8)}/page`
  );
  return (
    'https://www.facebook.com/dialog/share' +
    `?app_id=${import.meta.env.VITE_FACEBOOK_APP_ID}` +
    '&display=popup' +
    '&hashtag=Created with %23Reflectography %23Pulse' +
    `&href=${href}`
  );
};
